import { Component, Input } from '@angular/core';
import { ComponentBase, DeploymentContext, Summary } from '@Common';
import { LocalizedTextIds } from 'company-finder-common';

@Component({
	selector: 'strategic-collaboration',
	templateUrl: './strategic-collaboration.component.html',
	styleUrls: ['./strategic-collaboration.component.scss'],
	standalone: false,
})
export class StrategicCollaborationComponent extends ComponentBase {
	public isShowingTooltip = {
		publiclyOffered: false,
		strategicRelationships: false,
	};
	@Input()
	public summary: Summary;
	public title = this.Loc(LocalizedTextIds.StrategicCollaborationTitle);

	public constructor(dc: DeploymentContext) {
		super(dc);
	}

	public showTooltip(whichTooltip: string): void {
		this.isShowingTooltip[whichTooltip] = true;
	}

	public hideTooltip(whichTooltip: string): void {
		this.isShowingTooltip[whichTooltip] = false;
	}

	public getSumSplit(formattedCurrency: string, index: number): string {
		const items = formattedCurrency?.split(' ') ?? [];
		return index >= 0 && index < items.length
			? items[index]
			: formattedCurrency;
	}
}
